import { INCOME_VALUE_LIST } from 'constants/searchCondition';
import { useCallback, useState } from 'react';

/**
 * 年収に関するhooks
 * @param initialIncomeValue
 * @returns 年収の値と更新する関数を含むオブジェクト
 */
export const useSearchIncome = (initialIncomeValue: {
  lowerIncomeData: string;
  upperIncomeData: string;
}) => {
  const [lowerIncome, setLowerIncome] = useState(
    initialIncomeValue.lowerIncomeData
  );
  const [upperIncome, setUpperIncome] = useState(
    initialIncomeValue.upperIncomeData
  );
  const [isIncomeRangeError, setIsIncomeRangeError] = useState(false);

  const updateUpperIncome = useCallback((value: string) => {
    setUpperIncome(value);
    setIsIncomeRangeError(false);
  }, []);

  const updateLowerIncome = useCallback((value: string) => {
    setLowerIncome(value);
    setIsIncomeRangeError(false);
  }, []);

  const selectedLowerIncome = INCOME_VALUE_LIST.find(
    (list) => list.id === lowerIncome
  )?.value;

  const selectedUpperIncome = INCOME_VALUE_LIST.find(
    (list) => list.id === upperIncome
  )?.value;

  // 選択状態クリア処理
  const clearIsSelectedIncome = () => {
    setUpperIncome('0');
    setLowerIncome('0');
    setIsIncomeRangeError(false);
  };

  return {
    upperIncome,
    lowerIncome,
    setLowerIncome,
    setUpperIncome,
    selectedLowerIncome,
    selectedUpperIncome,
    isIncomeRangeError,
    setIsIncomeRangeError,
    updateUpperIncome,
    updateLowerIncome,
    clearIsSelectedIncome,
  };
};
